import { Directive, OnDestroy, AfterViewInit } from '@angular/core';
import { fromEvent, Observable, Subscription } from 'rxjs';
// import { throttleTime } from 'rxjs/internal/operators/throttleTime';
import { DeviceDetectorService } from 'src/app/services/device-detector.service';
import { DeviceTypes } from 'src/models/DeviceTypes';

@Directive({
    selector: '[asgDeviceScreenAdjuster]',
    standalone: true
})
export class DeviceScreenAdjusterDirective implements AfterViewInit, OnDestroy {
  private currentWdith: number = document.body.clientWidth;
  private currentHeight: number = document.body.clientHeight;
  private resizeObservable: Observable<Event>;
  private resizeSubscription: Subscription;
  private readonly mobile = {
    min: 0,
    max: 812
  };
  tablet = {
    min: 813,
    max: 1024
  };
  desktop = {
    min: 1025
  };
  constructor(
    private deviceDetectorService: DeviceDetectorService
  ) { }

  ngAfterViewInit() {
    this.onResize(this.currentWdith, this.currentHeight);
    // this.resizeObservable = fromEvent(window, 'resize').pipe(throttleTime(500));
    this.resizeObservable = fromEvent(window, 'resize');
    this.resizeSubscription = this.resizeObservable.subscribe((evt: any) => {
      if (evt.type === 'resize') {
        if (this.currentWdith !== evt.target.innerWidth || this.currentHeight !== evt.target.innerHeight) {
          this.currentWdith = evt.target.innerWidth;
          this.currentHeight = evt.target.innerHeight;
          this.onResize(evt.target.innerWidth, evt.target.innerHeight);
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }

  private onResize(width: number, height: number) {
    this.deviceDetectorService.deviceScreenDimensions = { width, height };
    switch (true) {
      case width > this.desktop.min:
        this.deviceDetectorService.deviceType = DeviceTypes.DESKTOP;
        break;
      case width <= this.tablet.max && width >= this.tablet.min:
        this.deviceDetectorService.deviceType = DeviceTypes.TABLET;
        break;
      case width <= this.mobile.max && width >= this.mobile.min:
        this.deviceDetectorService.deviceType = DeviceTypes.MOBILE;
        break;
      default:
        this.deviceDetectorService.deviceType = DeviceTypes.DESKTOP;
        break;
    }
  }

}
